import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../api/Axiosinstance";

/**
 * Public query that returns whether the platform is currently in maintenance mode.
 * Does not require authentication so the landing experience can decide whether
 * to show the maintenance screen before the user logs in.
 */
export const useMaintenanceStatus = () => {
  return useQuery({
    queryKey: ["public", "maintenance"],
    queryFn: async () => {
      const response = await axiosInstance.get("/settings/maintenance");
      return response.data?.data ?? response.data;
    },
    staleTime: 1000 * 60, // 1 minute
    refetchOnWindowFocus: true,
    retry: false,
  });
};
